export enum OneToOneMeetingLength {
    FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
    THIRTY_MINUTES = 'THIRTY_MINUTES',
    FORTY_FIVE_MINUTES = 'FORTY_FIVE_MINUTES',
    SIXTY_MINUTES = 'SIXTY_MINUTES'
}